<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre de la zona :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. interior, terraza"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="!disableDirectPaymentSwitch">
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Acepta pago directo? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-radio-group v-model="input.acceptDirectPayment" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row v-if="itemId !== 'addZone'">
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Activo :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1 text-left">
                <v-switch
                  style="display: inline-block"
                  v-model="input.active"
                  @change="markOneZoneActive($event)"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Selector de cartas :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1 text-left">
                <v-select
                  v-model="selectedMenus"
                  :items="menus"
                  label="Selecciona las Cartas"
                  item-text="name"
                  item-value="id"
                  multiple
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggle">
                      <v-list-item-action>
                        <v-icon
                          :color="
                            selectedMenus.length > 0 ? 'indigo darken-4' : ''
                          "
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Todas
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {
  qrZoneCollection,
  saveQrZone,
  updateQrZone
} from "@/collections/qrZone";
import { menuGroupCollection } from "@/collections/menuGroup";
import { getQRsByZone, updateQR } from "@/collections/qrs";
import moment from "moment";
import Loader from "../../common/Loader";
import { menusCollection } from "@/collections/menus";

const EMPTY_INPUT = {
  name: "",
  acceptDirectPayment: false,
  active: false,
  selectedMenu: []
};

export default {
  name: "zone-table-qr-dialog",
  components: { Loader },
  props: ["disableDirectPaymentSwitch"],
  data: () => ({
    itemId: "addZone",
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      name: [v => (!!v && !!v.trim()) || "Zona es requerido"]
    },
    zoneTablesQRCollection: [],
    input: EMPTY_INPUT,
    dialogLoader: true,
    menusCollection: [],
    selectedMenus: [],
    menuGroupCollection: []
  }),
  firestore() {
    return {
      zoneTablesQRCollection: qrZoneCollection,
      menusCollection: menusCollection.where("active", "==", true),
      menuGroupCollection: menuGroupCollection.where("active", "==", true)
    };
  },
  computed: {
    likesAllMenus() {
      return this.selectedMenus.length === this.menus.length;
    },
    likesSomeMenus() {
      return this.selectedMenus.length > 0 && !this.likesAllMenus;
    },
    icon() {
      if (this.likesAllMenus) return "mdi-checkbox-marked";
      if (this.likesSomeMenus) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    menus() {
      let cloneMenus = JSON.parse(JSON.stringify(this.menusCollection));
      let cloneMenuGroup = JSON.parse(JSON.stringify(this.menuGroupCollection));

      let defautOptionArray = [
        {
          name: "Comidas",
          id: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
        },
        {
          name: "Bebidas",
          id: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID,
          checked: false
        },
        {
          name: "Postres",
          id: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID,
          checked: false
        }
      ];
      cloneMenus = [...defautOptionArray, ...cloneMenus, ...cloneMenuGroup];
      return cloneMenus;
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllMenus) {
          this.selectedMenus = [];
        } else {
          this.selectedMenus = this.menus.slice();
        }
      });
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addZone") {
          // Create New

          let found = this.zoneTablesQRCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
              this.input.name.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }

          await saveQrZone(this.buildZone());
        } else {
          // check update unique name
          let found = this.zoneTablesQRCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim() && x.id !== this.itemId
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Update Existing
          await updateQrZone(this.itemId, this.buildZone());
        }
        this.showSuccessMessage("Zona guardado");

        this.close();
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "save/update_zone_tables",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
        return;
      }
    },
    async markOneZoneActive(value) {
      try {
        await updateQrZone(this.itemId, { active: value });

        let qrsByZone = await getQRsByZone(this.itemId);
        qrsByZone.forEach(async doc => {
          try {
            await updateQR(doc.id, { active: value });
          } catch (error) {
            // eslint-disable-next-line
            this.setlogError(
              "update_QR",
              "Obtained error message in markOneZoneActive()",
              error.stack,
              this.$options.name
            );
          }
        });
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "update/qr_zone/qr",
          "Obtained error message in markOneZoneActive()",
          error.stack,
          this.$options.name
        );
      }
    },
    buildZone() {
      let now = moment().format();
      if (this.likesAllMenus) {
        this.input.selectedMenu = ["all"];
      } else {
        this.input.selectedMenu =
          this.selectedMenus &&
          this.selectedMenus[0] &&
          this.selectedMenus[0].id
            ? this.selectedMenus.map(item => {
                return item.id;
              })
            : this.selectedMenus;
      }
      return { ...this.input, updated_on: now };
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (this.itemId === "addZone") {
        setTimeout(() => {
          this.title = "Crear Zona";
        }, 100);
        this.dialogLoader = false;
        return;
      }

      setTimeout(() => {
        this.title = "Editar Zona";
      }, 100);

      setTimeout(() => {
        let zone = this.zoneTablesQRCollection.find(x => x.id === this.itemId);
        this.selectedMenus = [];
        if (zone) {
          let foundAll = zone.selectedMenu.some(item => item === "all");
          if (foundAll) {
            this.selectedMenus = this.menus;
          } else {
            this.menus.forEach(item => {
              let found = zone.selectedMenu.some(menu => menu === item.id);
              if (found) {
                this.selectedMenus.push(item);
              }
            });
          }
          this.input = zone;
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.input = EMPTY_INPUT;
      this.selectedMenus = [];
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped lang="scss"></style>
